import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { MobileHeaderComponent } from '../../components/mobile-header/mobile-header.component';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-register-success',
  standalone: true,
  imports: [CommonModule, MatButtonModule, SidebarComponent, MobileHeaderComponent, TranslateModule],
  templateUrl: './register-success.component.html',
  styleUrl: './register-success.component.scss'
})
export class RegisterSuccessComponent implements OnInit {
  isTokenValid: boolean | null = null;
  loading: boolean = true;
  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];

      console.log("token real",token)
      if (token) {
        this.verifyToken(token);
      } else {
        this.isTokenValid = false;
      }
    });
  }

  goToCompass() {
    this.router.navigate(['/dashboard/company/compass']);
  }

  verifyToken(token: string) {
    this.http.get(`${environment.url}/api/company/verify_email?token=${token}`)
      .pipe(
        catchError(() => of(false))
      )
      .subscribe((response: any) => {
        this.loading = false;
        console.log("response de la trucada",response)
        if (response) {
          this.isTokenValid = true;
          document.cookie = `access_token=${response.access_token}; path=/;`;
          document.cookie = `company_name=${response.company_name}; path=/;`;
        } else {
          this.isTokenValid = true;
        }
      });
  }

  continueRegister() {
    this.router.navigate(['/dashboard/company/create-job-offer/step-1']);
  }
}
